import React from 'react';
import { Text } from '@react-three/drei';
import { Typography } from '@mui/material';

function ElectricalBox({
  position,
  size,
  onHover,
  component,
  boxType = 'dc',
  onClick,
}) {
  const [width, height, depth] = size;
  const colors = {
    dc: '#f3f4f6',
    ac: '#e5e7eb',
    lto: '#fecaca',
    elcb: '#fca5a5',
  };
  const color = colors[boxType] || colors.dc;

  return (
    <group position={position}>
      <mesh
        onPointerOver={() => onHover(component.name)}
        onPointerOut={() => onHover(null)}
        onClick={() => onClick(component)}
        castShadow
        receiveShadow
      >
        <boxGeometry args={[width, height, depth]} />
        <meshLambertMaterial color={color} />
      </mesh>

      <mesh position={[0, 0, depth / 2 + 0.01]}>
        <planeGeometry args={[width * 0.9, height * 0.9]} />
        <meshLambertMaterial color={color === '#e5e7eb' ? '#f9fafb' : color} />
      </mesh>

      <mesh position={[width / 3, 0, depth / 2 + 0.02]}>
        <cylinderGeometry args={[0.1, 0.1, 0.05]} />
        <meshLambertMaterial color='#d1d5db' />
      </mesh>

      <mesh position={[-width / 3, height / 4, depth / 2 + 0.02]}>
        <sphereGeometry args={[0.08]} />
        <meshBasicMaterial color='#86efac' />
      </mesh>

      {Array.from({ length: 4 }).map((_, i) => (
        <mesh
          key={i}
          position={[-width / 4 + i * 0.3, -height / 3, depth / 2 + 0.01]}
        >
          <cylinderGeometry args={[0.05, 0.05, 0.02]} />
          <meshLambertMaterial color='#d1d5db' />
        </mesh>
      ))}

      <mesh position={[-width / 2 - 0.1, 0, 0]}>
        <boxGeometry args={[0.2, height * 0.6, depth * 0.2]} />
        <meshLambertMaterial color='#e5e7eb' />
      </mesh>
      <mesh position={[width / 2 + 0.1, 0, 0]}>
        <boxGeometry args={[0.2, height * 0.6, depth * 0.2]} />
        <meshLambertMaterial color='#e5e7eb' />
      </mesh>
      <group position={[0, height + 5, 0]}>
        {/* First line - BIG FONT */}
        <Text
          fontSize={1.2}
          color='black'
          anchorX='center'
          anchorY='middle'
          outlineColor='#000000ff'
          outlineWidth={0.01}
          fontWeight={700}
          position={[0, 0, 0]}
        >
          {component.name}
        </Text>

        {/* Next 2 lines - SMALL FONT only if value exists */}
        {(component.details?.Brand_name ||
          component.details?.Quantity ||
          component.details?.Specification) && (
          <Text
            fontSize={0.9}
            color='black'
            anchorX='center'
            anchorY='top'
            position={[0, -1.4, 0]}
          >
            {`${component.details?.Brand_name || ''}\nx${component.details?.Quantity || '0'}\n${component.details?.Specification || ''}`}
          </Text>
        )}
      </group>
    </group>
  );
}

export default ElectricalBox;
